import darkLogo from '../../../assets/svg/netnetix-logo.svg';
import lightLogo from '../../../assets/svg/netnetix-logo-white.svg';

export default function logo(custom_style) {
    return( <>
        <img src={darkLogo} className='logoClass' style={custom_style}/>
        <img src={lightLogo} className='logoDarkClass' style={custom_style}/>
    </>)
}
